import { t } from 'i18next';
import { useState, useEffect } from 'react';

import { Stack } from '@mui/system';
import { Card, TextField, Typography, CardContent } from '@mui/material';

// ----------------------------------------------------------------------

type IdibuAuthState = {
  app_id: string;
  app_secret: string;
};

type Props = {
  onChange: (state: IdibuAuthState) => void;
};

export default function IdibuAuthSettings({ onChange }: Props) {
  const [appId, setAppId] = useState('');
  const [appSecret, setAppSecret] = useState('');

  useEffect(() => {
    onChange({ app_id: appId, app_secret: appSecret });
  }, [appId, appSecret, onChange]);

  return (
    <Stack spacing={3}>
      <Typography variant="h6">
        {t('integrations.manual_auth.idibu.title')}
      </Typography>

      <TextField
        fullWidth
        label={t('integrations.manual_auth.idibu.app_id')}
        value={appId}
        onChange={(e) => setAppId(e.target.value)}
        placeholder={t('integrations.manual_auth.idibu.app_id_placeholder')}
      />

      <TextField
        fullWidth
        label={t('integrations.manual_auth.idibu.app_secret')}
        value={appSecret}
        onChange={(e) => setAppSecret(e.target.value)}
        placeholder={t('integrations.manual_auth.idibu.app_secret_placeholder')}
        type="password"
      />
    </Stack>
  );
}